import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Typography,
  Card,
  Alert
} from '@mui/joy';
import { useAuth } from '../context/AuthContext';

const Signup = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);

    const result = await register(
      formData.email,
      formData.password,
      formData.name,
      formData.mobile
    );

    if (result.success) {
      navigate('/stock');
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        padding: 2
      }}
    >
      <Card sx={{ width: '100%', maxWidth: 400 }}>
        <Typography level="h2" sx={{ mb: 2, textAlign: 'center', color: '#eb7a24' }}>
          Dstock Signup
        </Typography>

        {error && (
          <Alert color="danger" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <FormControl sx={{ mb: 2 }}>
            <FormLabel>Name</FormLabel>
            <Input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter your name"
              sx={{
                '&:hover': { borderColor: '#ea7a23' },
                '&:focus-within': { borderColor: '#ea7a23' }
              }}
            />
          </FormControl>

          <FormControl sx={{ mb: 2 }}>
            <FormLabel>Email</FormLabel>
            <Input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Enter your email"
              sx={{
                '&:hover': { borderColor: '#ea7a23' },
                '&:focus-within': { borderColor: '#ea7a23' }
              }}
            />
          </FormControl>

          <FormControl sx={{ mb: 2 }}>
            <FormLabel>Mobile</FormLabel>
            <Input
              type="tel"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              placeholder="Enter your mobile number"
              sx={{
                '&:hover': { borderColor: '#ea7a23' },
                '&:focus-within': { borderColor: '#ea7a23' }
              }}
            />
          </FormControl>

          <FormControl sx={{ mb: 2 }}>
            <FormLabel>Password</FormLabel>
            <Input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Enter your password"
              sx={{
                '&:hover': { borderColor: '#ea7a23' },
                '&:focus-within': { borderColor: '#ea7a23' }
              }}
            />
          </FormControl>

          <FormControl sx={{ mb: 2 }}>
            <FormLabel>Confirm Password</FormLabel>
            <Input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              placeholder="Confirm your password"
              sx={{
                '&:hover': { borderColor: '#ea7a23' },
                '&:focus-within': { borderColor: '#ea7a23' }
              }}
            />
          </FormControl>

          <Button
            type="submit"
            loading={loading}
            fullWidth
            sx={{
              backgroundColor: '#eb7a24',
              '&:hover': { backgroundColor: '#cc6a1f' },
              mb: 2
            }}
          >
            Sign Up
          </Button>

          <Typography level="body-sm" sx={{ textAlign: 'center' }}>
            Already have an account? <Link to="/login" style={{ color: '#eb7a24' }}>Login</Link>
          </Typography>
        </form>
      </Card>
    </Box>
  );
};

export default Signup;

